import { KpiCard } from "../shared/components";
import { formatCurrency, formatPct } from "../shared/format";
import type { TopKpisDto } from "@/types/capitalMarketsDashboard";

/**
 * SPV Pool v1.0 §4.7 — the dashboard's top KPI strip. Six cards wide on
 * desktop, wrapping on narrower viewports.
 */
export function TopKpisRow({
  kpis,
  loading,
}: {
  kpis: TopKpisDto | undefined;
  loading: boolean;
}) {
  const dash = "—";
  return (
    <div
      className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-space-3"
      data-testid="top-kpis-row"
    >
      <KpiCard
        label="Total AUM"
        value={loading ? dash : formatCurrency(kpis?.totalAum)}
        hint="contributed principal"
      />
      <KpiCard
        label="Total Committed"
        value={loading ? dash : formatCurrency(kpis?.totalCommitted)}
        hint="across active pools"
      />
      <KpiCard
        label="Total Funded"
        value={loading ? dash : formatCurrency(kpis?.totalFunded)}
        hint="raised to date"
      />
      <KpiCard
        label="Investment Fill"
        value={loading ? dash : formatPct(kpis?.aggregateInvestmentFillPct)}
        hint="committed / AUM"
      />
      <KpiCard
        label="Active Pools"
        value={loading ? dash : (kpis?.activePoolCount ?? 0)}
        hint="active pools"
      />
      <KpiCard
        label="Investors"
        value={loading ? dash : (kpis?.investorCount ?? 0)}
        hint="committed or funded"
      />
    </div>
  );
}
